<template>
  <section class="chan-pin-man-yi-du">
    <PageBlock title="产品满意度">
      <div class="content">
        <div ref="chart" style="width: 100%;height: 260px;"></div>
      </div>
    </PageBlock>
  </section>
</template>

<script>
import PageBlock from "@/components/page-block.vue";
import * as echarts from "echarts";

export default {
  name: 'chan-pin-man-yi-du',
  components: {PageBlock},
  props: {
    productSatisfactionVoList: Array
  },
  watch: {
    productSatisfactionVoList: {
      handler: (val) => {
        this.chart.dispose()
        this.initChart()
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chart);
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: (params) => {
            let topDiv = '<div>'
            params.forEach((item, index) => {
              if (index === 0) {
                let data = this.productSatisfactionVoList[item.dataIndex]
                topDiv += `<div>${data.year}年${data.month}月</div>`
              }
              topDiv += `<div>${item.marker}<span>${item.seriesName}: ${item.value}</span></div>`
            })
            topDiv += '<div>'
            return topDiv
          }
        },
        legend: {
          data: ['退货率', '好评率'],
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '40',
          bottom: 20
        },
        xAxis: [
          {
            type: 'category',
            data: this.productSatisfactionVoList.map(item => item.month),
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '退货率',
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '好评率',
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '退货率',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + '';
              }
            },
            data: this.productSatisfactionVoList.map(item => item.refundRate),
          },
          {
            name: '好评率',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + '';
              }
            },
            data: this.productSatisfactionVoList.map(item => item.goodCommentRate),
          },
        ]
      }
      this.chart.setOption(option);
    },
  },
};
</script>

<style scoped>
.chan-pin-man-yi-du {
}
</style>
